import React from 'react';
import SVG from 'react-inlinesvg';
import LOGO from "../../static/logo.svg"; 
import { Link, DirectLink, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'

import './_features.scss';

const NewsListing = props =>
  (<section className="features" id="features" name="features">
  	
    <div className="container">
      <div className="svg-background">
  		<SVG src={LOGO} />
  	  </div>
      <div className="row">
        <div className="col-12">
        	<div className="featured-title">
	        		<div className="row">
	        			<div className="col-lg-6">
	        				<h2>{props.data.title}</h2>
	        			</div>
					</div>
        	</div>
        		
        	
        	<div className="platter">
	        		<div className="row">
		        		<div className="col-md-6 col-lg-4">
		        			<p className="lead">{props.data.parts[0].content}</p>
							<Link href="#about" className="btn btn-primary" to="about" smooth={true} duration={500} offset={350}>{props.data.parts[1].content}</Link>
							
						</div>
					</div>
					
	        </div>
        </div>
      </div>
    </div>
  </section>);

export default NewsListing;



// WEBPACK FOOTER //
// ./src/components/features/index.js